<template>
  <div class='section'>
    <div class='intro'>
      <p>
        Hello, I am Divyanth Jayaraj.
      </p>
      <p>
        I am the Lead Front End developer in Mudrex, a zero programming algo-trading platform.
      </p>
      <p>
        Before Mudrex, I built rich UIs as a consultant for various clients across the United States for over 4.5 years.
      </p>
      <p>
        This website was built from scratch. It serves as a testament to my skill as a software developer.
        You can find its source code <a href='https://github.com/divyanthj/personal-website' target='_blank'>here</a>.
      </p>
      <p>
        Go ahead and navigate through the website to learn more about me.
      </p>
    </div>
  </div>
</template>
<script>
export default {

}
</script>
<style scoped>
.intro {
  font-size: 14px;
  overflow: auto;
  height: 14em;
}
</style>
